import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import Brand from "@/components/Brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-paper">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 pt-24 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Logo size="md" />
            <p className="label-mono mt-10">Dublin, Ireland · traeva.ie</p>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-10">
            <div>
              <p className="label-mono mb-5">Site</p>
              <ul className="space-y-3">
                <li><Link to="/how-it-works" className="text-sm text-ink hover:text-coral transition-colors">Fares</Link></li>
                <li><Link to="/bearing" className="text-sm text-ink hover:text-coral transition-colors">The Bearing</Link></li>
                <li><Link to="/about" className="text-sm text-ink hover:text-coral transition-colors">Operator</Link></li>
                <li><Link to="/contact" className="text-sm text-ink hover:text-coral transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <p className="label-mono mb-5">Reach</p>
              <ul className="space-y-3">
                <li><a href="mailto:hello@traeva.ie" className="text-sm text-ink hover:text-coral transition-colors">hello@traeva.ie</a></li>
                <li><span className="text-sm text-ink-muted">Dublin, Ireland</span></li>
              </ul>
            </div>
            <div>
              <p className="label-mono mb-5">Engagement</p>
              <ul className="space-y-3">
                <li><span className="text-sm text-ink-muted">3 partners / year</span></li>
                <li><span className="text-sm text-ink-muted">By referral & application</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-line flex flex-col sm:flex-row justify-between gap-4 label-mono">
          <p>© {new Date().getFullYear()} <Brand className="!text-[inherit]" /> · Trade + Via — the trade route</p>
          <p>Dublin · Ireland · traeva.ie</p>
        </div>
      </div>
    </footer>
  );
}
